export default "__VITE_ASSET__B78Bo25A__"